import { render, staticRenderFns } from "./crossing.vue?vue&type=template&id=563c3563&scoped=true&"
import script from "./crossing.vue?vue&type=script&lang=js&"
export * from "./crossing.vue?vue&type=script&lang=js&"
import style0 from "./crossing.vue?vue&type=style&index=0&id=563c3563&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563c3563",
  null
  
)

export default component.exports